module.exports = __webpack_public_path__ + "bd0c147a.svg";